export default {
  CLEAR_LANGUAGE_STATE: state => (state.languages = []),

  store: (state, payload) => {
    let _languages = [...state.languages];

    _languages = [..._languages, { ...payload }];

    state.languages = [..._languages];
  },

  delete: (state, payload) => {
    let _languages = [...state.languages];

    _languages = [
      ..._languages.slice(0, payload.index),
      ..._languages.slice(payload.index + 1)
    ];

    state.languages = [..._languages];
  },

  index: (state, payload) => (state.languages = [...payload])
};
